// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/AuditHome/index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/AuditHome/index.tsx");
  import.meta.hot.lastModified = "1732036225889.9033";
}
// REMIX HMR END

import clsx from "clsx";
import ContentWrapper from "~/components/ContentWrapper";
import DocTahedroidImage, { resultMapping } from "../DocTahedroidImage";
import AuditHomeFormView from "./FormView";
import { useMemo } from "react";
import SpeedResult from "./SpeedResult";
import OpengraphResult from "./OpengraphResult";
import { useLoaderData, useNavigation } from "@remix-run/react";
import WaitingResult from "./WaitingResult";
import { calculateAttributesPassing } from "../utils";
const variantToComponentMap = {
  form: () => <AuditHomeFormView />,
  speed: ({
    audit
  }) => <SpeedResult variant="approval" psi={audit.psi} crux={audit.crux} reportId={audit.reportId} />,
  opengraph: ({
    audit
  }) => <OpengraphResult audit={audit} />,
  loading: () => <WaitingResult />
};
export default function AuditHome() {
  _s();
  const {
    audit
  } = useLoaderData();
  const navigation = useNavigation();
  const loading = navigation.state !== "idle" && navigation.location.search !== "" && navigation.location.pathname === "/";
  const variantFromAudit = useMemo(() => {
    if (!audit) {
      return "form";
    }
    if (audit.psi || audit.crux) {
      return "speed";
    }
    if (audit.opengraph) {
      return "opengraph";
    }
    return "form";
  }, [audit]);
  const variant = loading ? "loading" : variantFromAudit;
  const AsideComponent = variantToComponentMap[variant];
  const attributes = calculateAttributesPassing(audit);
  const result = variant === "form" ? "default" : attributes?.variant || "boost";
  const {
    image
  } = resultMapping[variant === "loading" ? "waiting" : result];
  return <ContentWrapper Item="div" spacing="primary" className="w-full bg-neutral-100">
      <section className={clsx("flex flex-col items-center", "md:grid md:grid-cols-20 md:text-left md:items-stretch")}>
        <div className="md:col-span-9 md:row-start-1 md:col-start-1 mb-4 md:mb-0">
          <AsideComponent audit={audit} />
        </div>

        <DocTahedroidImage className={clsx("mt-4 md:mt-0 self-center object-scale-down md:col-span-9 md:row-start-1", "md:col-start-12")} variant={loading ? "waiting" : image} />
      </section>
    </ContentWrapper>;
}
_s(AuditHome, "lVk3qc9I6aZPvb3S2wrfyTK3vCc=", false, function () {
  return [useLoaderData, useNavigation];
});
_c = AuditHome;
var _c;
$RefreshReg$(_c, "AuditHome");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;